<template>
  <smd-one-col-layout class="modal-terms-and-conditions-weighnow">
    <smd-header slot="header" nav>
      <span class="ns-icon-ico028"
            slot="left-actions"
            @click="closeModal"/>

      <text-string label-id="txt131"/>

      <span class="ns-icon-ico001"
            slot="right-actions">
        <span class="path1"></span>
        <span class="path2"></span>
      </span>
    </smd-header>

    <div class="smd-form__row">
      <text-string label-id="txt588"/>
    </div>

    <div class="smd-checkbox__row">
      <smd-checkbox v-model="termsAgreed">
        <text-string label-id="txt589"/>
      </smd-checkbox>
    </div>

    <div class="smd-checkbox__row">
      <smd-checkbox v-model="novoTermsAgreed">
        <text-string label-id="txt1441"/>
      </smd-checkbox>
    </div>

    <div class="smd-form__row justify-content-center">
      <text-string class="text-center" label-id="txt1443"/>
    </div>
  </smd-one-col-layout>
</template>

<script>
  import CloseModalMixin from '@/mixins/close-modal-mixin';
  import {mapFields} from 'vuex-map-fields';

  export default {
    name: 'modal-terms-and-conditions-weighnow',
    mixins: [CloseModalMixin],
    computed: {
      ...mapFields({
        termsAgreed: 'termsAgreed',
        novoTermsAgreed: 'novoTermsAgreed',
      }),
    },
  }
</script>

<style lang="scss">
  .modal-terms-and-conditions-weighnow {
    .smd-checkbox__row {
      margin-bottom: space(m);

      .smd-checkbox {
        align-items: flex-start;
      }
    }
  }
</style>
